module.exports = __webpack_public_path__ + "img/642f532e38fe5b39a964ad41d08afccd.png";